import React from 'react';
import { string, number, bool, func } from 'prop-types';

export default function PageView({
    pageLinkClassName,
    pageClassName,
    selected,
    page,
    activeClassName,
    onClick
}) {
    const pageClass = selected
        ? `${pageClassName} ${activeClassName}`
        : pageClassName;

    return (
        <li className={`c-r-pagination__item ${pageClass}`}>
            <button onClick={onClick} className={pageLinkClassName}>
                {page}
            </button>
        </li>
    );
}

PageView.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    page: number,
    pageLinkClassName: string,
    pageClassName: string,
    activeClassName: string,
    selected: bool,
    onClick: func.isRequired
    /* eslint-enable react/no-typos */
};

PageView.defaultProps = {
    page: 0,
    pageLinkClassName: '',
    pageClassName: '',
    activeClassName: '',
    selected: 0
};
